// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3BkAN","right":"styles_right__38TiI"};